export const formatPercentage = (
  description: any,
  rate: any,
  length: number
) => {
  var result = rate && rate.slice(-1) === '%' ? format(rate) : rate;

  return getDescription(description, `(${result})`, length);
};

const format = (rate: string): string =>
  `${parseFloat(rate.substr(0, rate.length - 1))}%`;

const getDescription = (
  description: any,
  formatedRate: string,
  length: number
): string => {
  let result = `${description || ''} ${formatedRate}`;
  if (result.length > length) {
    result = `${description.substr(
      0,
      length - (formatedRate.length + 3)
    )}... ${formatedRate}`;
  }
  return result;
};

export const getRate = (rate: string) =>
  rate?.length > 0 ? '(' + rate + ')' : '';

export * as PipeHelper from './pipe-helper';
